import { Slider } from '../../components/Slider';
import { useEditorStore } from '../../store/editorStore';

// Lens corrections (distortion + vignette) and perspective/geometry transform.
export function LensPanel() {
  const state = useEditorStore((s) => s.state);
  const set = useEditorStore((s) => s.set);

  return (
    <>
      <p className="hint">Lens Corrections</p>
      <Slider
        label="Distortion"
        help="lensCorrections"
        value={state.lensDistortion}
        min={-100}
        max={100}
        onChange={(v) => set('lensDistortion', v)}
      />
      <Slider
        label="Vignette"
        value={state.vignetteAmount}
        min={-100}
        max={100}
        onChange={(v) => set('vignetteAmount', v)}
      />
      <Slider
        label="Midpoint"
        value={state.vignetteMidpoint}
        min={0}
        max={100}
        defaultValue={50}
        onChange={(v) => set('vignetteMidpoint', v)}
      />

      <p className="hint">Transform / Geometry</p>
      <Slider
        label="Vertical"
        help="transform"
        value={state.perspectiveVertical}
        min={-100}
        max={100}
        onChange={(v) => set('perspectiveVertical', v)}
      />
      <Slider
        label="Horizontal"
        value={state.perspectiveHorizontal}
        min={-100}
        max={100}
        onChange={(v) => set('perspectiveHorizontal', v)}
      />
      <Slider
        label="Rotate"
        value={state.rotate}
        min={-10}
        max={10}
        step={0.1}
        onChange={(v) => set('rotate', v)}
      />
    </>
  );
}
